{
  "seo": {
    "fallbackTitle": "Learning Path",
    "fallbackDescription": "Guided learning steps and activities."
  },
  "title": "Learning Paths",
  "states": {
    "loading": "Loading learning path...",
    "notFound": "Learning path not found."
  },
  "childFallback": "Child",
  "actions": {
    "assignPath": "Assign path",
    "reassignPath": "Reassign path",
    "startPath": "Start path",
    "switchPath": "Switch to this path",
    "review": "Review",
    "viewQuestion": "View question",
    "redo": "Redo",
    "startWarmup": "Start mid-boss quiz",
    "startFinal": "Start final boss quiz",
    "restartPath": "Restart path"
  },
  "restartConfirm": "This will clear all progress on this path and start it over from step 1. Continue?",
  "progress": "{completed} / {total} steps done",
  "steps": {
    "stepLabel": "Step {number}",
    "done": "Done",
    "upNext": "Up next",
    "locked": "Locked",
    "warmup": "Mid-Boss Quiz · Normal mode",
    "finalRound": "Final Boss · Hard mode",
    "quiz": "Quiz",
    "question": "Question",
    "boss": "Final Boss",
    "midBossBadge": "Mid-Boss"
  },
  "celebration": {
    "title": "Path complete!",
    "body": "You beat the boss round and finished the whole path."
  },
  "notActive": {
    "childMessage": "This path isn't your active one right now. Click \"Start path\" to work on it and save your progress!",
    "parentMessage": "This path isn't assigned to this child yet — progress won't be saved until you assign it."
  },
  "viewMode": {
    "map": "Quest Map",
    "list": "List View"
  },
  "map": {
    "start": "START",
    "checkpoint": "Checkpoint",
    "youAreHere": "You are here!",
    "tapToPlay": "Tap to start challenge"
  }
}
